/**
 * Authentication Server error codes.
 * These codes *must* match those defined within Authentication Server.
 */
export enum AuthErrorCode {
    WRONG_PASSWORD = 16,
    USED_PASSWORD = 301,
    FORBIDDEN_WORDS = 201,
    PASSWORD_NOT_STRONG = 15
}

/**
 * Types of onboarding-related failure.
 */
export enum OnboardingError {
    TOTP_EXPIRED = 'expired',
    TOTP_NOT_EXISTING = 'not-found',
    ALREADY_REGISTERED = 'already-registered',
    GENERIC = 'generic'
}
